var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 97C75.2858 97 97 75.2858 97 48.5C97 21.7142 75.2858 0 48.5 0C21.7142 0 0 21.7142 0 48.5C0 75.2858 21.7142 97 48.5 97Z",
    fill: "url(#paint0_linear_4610_6597)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6004 97.0001H19.4004V34.2734C22.1436 34.2703 24.7735 33.1793 26.7132 31.2396C28.6529 29.2999 29.744 26.6699 29.7471 23.9268H67.2537C67.2508 25.2857 67.5174 26.6316 68.0381 27.8868C68.5588 29.142 69.3233 30.2815 70.2872 31.2393C71.245 32.2035 72.3845 32.9682 73.6398 33.489C74.8952 34.0098 76.2413 34.2764 77.6004 34.2734V97.0001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0252 53.8893H49.0397M49.0381 49.0393V42.5727M38.242 43.6769C42.143 36.7721 44.0943 33.3205 46.7715 32.4313C48.2431 31.9428 49.8331 31.9428 51.3047 32.4313C53.9819 33.3205 55.9332 36.7721 59.8342 43.6769C63.7368 50.58 65.6865 54.0332 65.1029 56.8462C64.7796 58.395 63.9874 59.7983 62.8363 60.8556C60.7444 62.781 56.8417 62.781 49.0381 62.781C41.2344 62.781 37.3318 62.781 35.2398 60.8572C34.0843 59.7901 33.2917 58.3881 32.9733 56.8478C32.388 54.0348 34.3394 50.5816 38.242 43.6769Z",
    stroke: "#4F46E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9057 69.8398H40.0923C39.0209 69.8398 38.1523 70.7084 38.1523 71.7798C38.1523 72.8513 39.0209 73.7198 40.0923 73.7198H56.9057C57.9771 73.7198 58.8457 72.8513 58.8457 71.7798C58.8457 70.7084 57.9771 69.8398 56.9057 69.8398Z",
    fill: "#DFEAFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7273 77.6001H34.274C33.2026 77.6001 32.334 78.4687 32.334 79.5401C32.334 80.6115 33.2026 81.4801 34.274 81.4801H62.7273C63.7987 81.4801 64.6673 80.6115 64.6673 79.5401C64.6673 78.4687 63.7987 77.6001 62.7273 77.6001Z",
    fill: "#DFEAFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4610_6597",
    x1: 48.5,
    y1: 0,
    x2: 48.5,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutAlert);
export default __webpack_public_path__ + "static/media/LogoutAlert.98931ef654ea51ddbea7ee42ca746b19.svg";
export { ForwardRef as ReactComponent };